import React from "react";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import axios from "axios";
import { data } from "jquery";

export default function BlogView(props) {
  const blog = props.blog;

  const removeBlog = (id) => {
    let password = prompt("Enter password");
    if (password === "delete") {
      axios
        .delete(`https://tamizhtechie-test.herokuapp.com/blog/${id}`)

        .then(
          (res) => props.removeBlog(res.data),
          alert("Blog removed please refresh page")
        )
        .catch((err) => console.log("err", err));
    } else {
      alert("Do your work");
    }
  };

  return (
    <div>
      <div className="container ">
        <div className="row">
          <div className="">
            {blog.reverse().map((newBlog) => {
              return (
                <div key={newBlog._id}>
                  <table id="blogview" className="">
                    <tr key={newBlog._id}>
                      <td>{newBlog.title}</td>
                      <td style={{ width: 90 }} className="text-right">
                        <button
                          onClick={() => removeBlog(newBlog._id)}
                          className="btn btn-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
